import React, { useState, useContext } from "react";
import { Box } from "@mui/material";
import AuthContext from "../store/AuthContext";
import CustomTabs from "../component/CustomTabs";
import AdminOperatorView from "./AdminOperatorView";
import AdminPlanView from "./AdminPlanView";
import AdminRoutesView from "./AdminRoutesView";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";

import RouterIcon from "@mui/icons-material/Router";
import StreetviewIcon from "@mui/icons-material/Streetview";
import AdminApiServices from "./AdminApiServices";
const AdminServices = () => {
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const canViewApiServices = [1, 5861, 5855, 5753].includes(user?.id);
  const canViewRoutesAndAll = [1].includes(user?.id);

  const tabs = [
    {
      label: "Operators",
      content: <AdminOperatorView />,
      icon: <MyLocationIcon />,
    },
    ...(canViewApiServices
      ? [
          {
            label: "API Services",
            content: <AdminApiServices />,
            icon: <DisplaySettingsIcon />,
          },
        ]
      : []),

    ...(canViewRoutesAndAll
      ? [
          {
            label: "Plans",
            content: <AdminPlanView />,
            icon: <StreetviewIcon />,
          },
        ]
      : []),

    ...(canViewRoutesAndAll
      ? [
          {
            label: "Routes",
            content: <AdminRoutesView />,
            icon: <RouterIcon />,
          },
        ]
      : []),
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <CustomTabs tabs={tabs} value={value} onChange={handleChange} />
    </Box>
  );
};

export default AdminServices;
